import React, { useRef, useState } from 'react'

import classNames from 'classnames'

import styles from './Button.module.scss'

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  btnType?:
    | 'primary'
    | 'outline_light'
    | 'outline_dark'
    | 'secondary_light'
    | 'secondary_dark'
  size?: 'small' | 'medium'
  validate?: boolean
  iconLeft?: string
  full?: boolean
}

/**
 * Button.
 *
 * @param {ButtonProps} props button's props
 * @returns {React.ReactElement<ButtonProps>} Button.
 */
export function Button(props: ButtonProps): React.ReactElement<ButtonProps> {
  const {
    children,
    validate,
    btnType = 'primary',
    className = '',
    size = '',
    iconLeft,
    full,
    onMouseDown,
    onMouseUp,
    ...rest
  } = props
  const ref = useRef<HTMLButtonElement>(null)
  const [pressed, setPressed] = useState(false)
  const btnClass = classNames([
    styles['button'],
    styles[size],
    className,
    {
      [styles[btnType]]: btnType,
      [styles.full]: full,
      [styles.pressed]: pressed,
    },
  ])

  const handleMouseDown = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    //Обрабатываем нажатие только левой кнопкой мыши
    if (e.button === 0) {
      // ref.current?.classList.add('pressed')
      setPressed(true)
    }

    if (onMouseDown) {
      onMouseDown(e)
    }
  }

  const handleMouseUp = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // ref.current?.classList.remove('pressed')
    setPressed(false)
    ref.current?.blur()
    if (onMouseUp) {
      onMouseUp(e)
    }
  }

  return (
    <button
      ref={ref}
      className={btnClass}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      {...rest}
    >
      {iconLeft && <i className={iconLeft} />}
      <span>{children}</span>
      {validate && <i className={styles.button__loader} />}
    </button>
  )
}
